/** @type {Styles} */
export const styles = {
  radio: {
    marginY: -0.875,
    marginRight: -1.125,
    '&.Mui-checked': {
      color: 'primary',
    },
    color: 'gray.40',
  },
  boxLarge: { alignItems: 'start' },
  box: {
    color: 'gray.80',
    border: 1,
    borderColor: 'gray.12',
    outline: '1px solid',
    outlineColor: 'transparent',
    backgroundColor: 'gray.0',
    boxSizing: 'border-box',
    borderRadius: 1,
    paddingY: 2,
    paddingX: 3,
    marginX: 0,
    minHeight: 64,
    '&:not(.Mui-disabled):hover': {
      borderColor: 'gray.40',
    },
  },
  boxLabel: {
    marginRight: 'auto',
  },
  boxChecked: {
    '&:not(.Mui-disabled)': {
      border: 1,
      borderColor: 'primary.main',
      color: 'primary.main',
      outlineColor: 'inherit',
      '&:hover': {
        borderColor: 'primary.main',
      },
    },
  },
  toolTipButton: {
    marginLeft: 1,
    marginBottom: 'auto',
    padding: 0,
    verticalAlign: 'text-bottom',
    '.MuiSvgIcon-root': { fontSize: 18 },
  },
  labelWrapper: { display: 'flex', flexDirection: 'row' },
  label: {
    typography: 'header4',
  },
  labelChecked: {
    fontWeight: 600,
    color: 'primary.main',
  },
  weightChange: {
    display: 'flex',
    flexDirection: 'column',
    '&:after': {
      content: 'attr(data-text)',
      typography: 'medium',
      height: 0,
      visibility: 'hidden',
      overflow: 'hidden',
      userSelect: 'none',
      pointerEvents: 'none',
      fontWeight: 600,
      '@media speech': {
        display: 'none',
      },
    },
  },
  weightChangeWarning: {
    '&:after': {
      paddingRight: 3.25,
    },
  },
  formControlLabel: {
    '.MuiFormControlLabel-label': {
      marginRight: 'auto',
      paddingRight: 2,
      alignSelf: 'center',
    },
    '&.Mui-disabled': {
      '.MuiRadio-root': { color: 'gray.16' },
      '.MuiTypography-root': { color: 'gray.40' },
      '.MuiIconButton-root': { color: 'gray.40' },
    },
    color: 'gray.40',
  },
  helperText: {
    typography: 'small',
    color: 'gray.64',
  },
  helperTextChecked: {
    color: 'primary.main',
  },
  boxText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  description: {
    typography: 'medium',
    marginTop: 1.5,
    color: 'gray.80',
  },
  icon: {
    fontSize: 22,
  },
  cardLabel: {
    typography: 'large',
  },
  cardBox: {
    marginTop: '0',
  },
  boxError: {
    '&:not(.Mui-disabled)': {
      border: 1,
      borderColor: 'error.main',
      '&:hover': {
        borderColor: 'error.main',
      },
    },
  },
}
